"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var index_1 = require("../../../_util/index");
var useConfig_1 = __importDefault(require("../../../_util/useConfig"));
// https://staticintl.cloudcachetci.com/cms/backend-cms/yyZ7256_base.png
// https://staticintl.cloudcachetci.com/cms/backend-cms/GTya588_body1.png
// https://staticintl.cloudcachetci.com/cms/backend-cms/N4K5919_body2.png
// https://staticintl.cloudcachetci.com/cms/backend-cms/8kLg131_icon1.png
// https://staticintl.cloudcachetci.com/cms/backend-cms/fJ8f695_icon2.png
// https://staticintl.cloudcachetci.com/cms/backend-cms/uH8Z460_icon3.png
// https://staticintl.cloudcachetci.com/cms/backend-cms/ZNAD522_left.png
// https://staticintl.cloudcachetci.com/cms/backend-cms/KYT7851_light.png
// https://staticintl.cloudcachetci.com/cms/backend-cms/RxtL011_right.png
function AnimFreetier() {
    var classPrefix = (0, useConfig_1.default)().classPrefix;
    (0, react_1.useEffect)(function () {
        (0, index_1.windowAddEventListener)(function () {
            (0, index_1.scaleAnimation)('freetier-animation-fake');
        }, 1);
    }, []);
    return (react_1.default.createElement("div", { className: "".concat(classPrefix, "-freetier-anim"), id: "freetier-animation-fake" },
        react_1.default.createElement("img", { className: "home-three-img-seven", src: "https://staticintl.cloudcachetci.com/cms/backend-cms/7HAW367_body1.png", alt: "Tencent Cloud Banner Animation" }),
        react_1.default.createElement("img", { className: "three-banner-light", src: "https://staticintl.cloudcachetci.com/cms/backend-cms/KYT7851_light.png", alt: "Tencent Cloud Banner Animation" }),
        react_1.default.createElement("img", { className: "three-banner-body2", src: "https://staticintl.cloudcachetci.com/cms/backend-cms/N4K5919_body2.png", alt: "Tencent Cloud Banner Animation" }),
        react_1.default.createElement("img", { className: "three-banner-icon1", src: "https://staticintl.cloudcachetci.com/cms/backend-cms/8kLg131_icon1.png", alt: "Tencent Cloud Banner Animation" }),
        react_1.default.createElement("img", { className: "three-banner-icon2", src: "https://staticintl.cloudcachetci.com/cms/backend-cms/fJ8f695_icon2.png", alt: "Tencent Cloud Banner Animation" }),
        react_1.default.createElement("img", { className: "three-banner-icon3", src: 'https://staticintl.cloudcachetci.com/cms/backend-cms/uH8Z460_icon3.png' }),
        react_1.default.createElement("img", { className: "three-banner-huan-left", src: "https://staticintl.cloudcachetci.com/cms/backend-cms/ZNAD522_left.png", alt: "Tencent Cloud Banner Animation" }),
        react_1.default.createElement("img", { className: "three-banner-huan-right", src: "https://staticintl.cloudcachetci.com/cms/backend-cms/RxtL011_right.png", alt: "Tencent Cloud Banner Animation" }),
        react_1.default.createElement("img", { className: "home-three-img-bg", src: "https://staticintl.cloudcachetci.com/cms/backend-cms/yyZ7256_base.png", alt: "Tencent Cloud Banner Animation" })));
}
exports.default = AnimFreetier;
//# sourceMappingURL=index.js.map